/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="18.26"
        height="19"
        viewBox="0 0 18.26 19"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M15.78 7.18h-2.8a10.12 10.12 0 0 0 .1-4.48A3.44 3.44 0 0 0 11.6.39 2.82 2.82 0 0 0 9.53.07l-.37.1v.39c0 7.3-3.38 7.67-4.06 7.67H0V19h5.59v-.83h.09l9.17.06a2.54 2.54 0 0 0 2.76-2.6c.05-.54.13-1.21.21-1.94v-.07c.14-1.27.3-2.71.41-4a2.33 2.33 0 0 0-.51-1.86 2.48 2.48 0 0 0-1.94-.58ZM4.59 18H.99V9.24h3.6Zm12.6-8.5c-.11 1.3-.27 2.76-.41 4.05v.2c-.07.66-.14 1.26-.18 1.75-.13 1.22-.62 1.7-1.77 1.7l-9.26-.06v-8c1.44-.22 4.44-1.48 4.56-8.2a1.81 1.81 0 0 1 .94.25 2.52 2.52 0 0 1 1 1.67 9.68 9.68 0 0 1-.25 4.6l-.23.66h4.21a1.59 1.59 0 0 1 1.16.27 1.34 1.34 0 0 1 .23 1.11Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'FacebookLikeIcon';

export default Icon;
